var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartRateAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 27.376 24.5661",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.636 6.2841C2.904 1.4741 8.524 -1.9199 13.876 4.6501C19.916 -2.7599 26.292 2.5041 26.376 8.1801C26.376 16.6301 16.266 23.5661 13.876 23.5661C12.446 23.5661 8.256 21.0861 5.118 17.2841",
    stroke: "#DE90DF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8757 11.2827H15.8757L12.8757 15.2827L8.87575 8.28271L5.87575 12.2827H1",
    stroke: "#DE90DF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRateAssessment);
export default __webpack_public_path__ + "static/media/heart-rate-assessment.5140b239f7d764ac1c155a931fa40d8f.svg";
export { ForwardRef as ReactComponent };